import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants';

import type { FormAnalytics } from '@/types/form';

const ANALYTICS_KEYS = {
    all: ['form-analytics'] as const,
    detail: (slug: string, params?: Record<string, string>) =>
        params && Object.keys(params).length > 0
            ? [...ANALYTICS_KEYS.all, slug, params] as const
            : [...ANALYTICS_KEYS.all, slug] as const,
};

export { ANALYTICS_KEYS as FORM_ANALYTICS_KEYS };

export interface AnalyticsFilters {
    date_from?: string;
    date_to?: string;
}

export function useFormAnalytics(slug: string, filters: AnalyticsFilters = {}) {
    return useQuery({
        queryKey: ANALYTICS_KEYS.detail(slug, filters as Record<string, string>),
        queryFn: async () => {
            const params: Record<string, string> = {};
            if (filters.date_from) params.date_from = filters.date_from;
            if (filters.date_to) params.date_to = filters.date_to;
            const { data } = await api.get<FormAnalytics>(API_ROUTES.formAnalytics(slug), { params });
            return data;
        },
        enabled: !!slug,
    });
}
